








import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { EVENTS } from '../../bus/events.const';
import { HorizontalScrollType } from '../../models';
import { SUBMODULES_PATHS } from '../../store';
import { CONFIG_GETTERS_KEYS } from '../../store/config/config.const';

@Component({
  computed: {
    ...mapGetters(SUBMODULES_PATHS.config, {
      isDocumentLtr: CONFIG_GETTERS_KEYS.isDocumentLtr
    })
  }
})
export default class HorizontalScrollTypeChecker extends Vue {

  isDestroyable = false;
  initialScrollLeft: number;
  $refs: {
    horizontalScroll: HTMLElement
  };

  setScrollType() {
    this.$x.emit(EVENTS.SetHorizontalScrollType, this.getScrollType());
    this.isDestroyable = true;
  }

  mounted() {
    if (this.$refs.horizontalScroll) {
      this.initialScrollLeft = this.$refs.horizontalScroll.scrollLeft;
      this.$refs.horizontalScroll.scrollBy({ left: -1 });
      this.$nextTick(() => this.setScrollType());
    }
  }

  getScrollType(): HorizontalScrollType {
    if (this.initialScrollLeft === 0) {
      if (this.$refs.horizontalScroll.scrollLeft < this.initialScrollLeft) {
        return HorizontalScrollType.NEGATIVE;
      }
      return HorizontalScrollType.REVERSE;
    }

    return HorizontalScrollType.DEFAULT;
  }
}
